<template>
  <div>
    <!-- <div class="aside__top">
      <div class="logoBox">
        <div class="logo">
          <img src="../../../../static/images/contactUs/icon1.png" />
          <span>笨笨虎</span>
        </div>
      </div>
      <div class="aside__top--right">
        <div class="quit-system" @click="loginOut">
          <span class="iconfont icon-quit"></span>
        </div>
        <el-dropdown trigger="click" placement="top" @command="handleDropDown">
          <span class="el-dropdown-link">
            <i class="el-icon-setting" style="font-size:26px;"></i>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">设备检测</el-dropdown-item>
            <el-dropdown-item command="b">切换账号</el-dropdown-item>
            <el-dropdown-item command="c">清除缓存</el-dropdown-item>
            <el-dropdown-item command="d">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div> -->
    <!--  <div class="headerInfo">
      <div class="left">
        <span>张晓迪</span>
      </div>
      <div class="right">
        <div class="aside__top--right">
          <el-dropdown trigger="click" placement="top" @command="handleDropDown">
            <span class="el-dropdown-link">
              <img src="../../../../static/images/icon1.png" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">设备检测</el-dropdown-item>
              <el-dropdown-item command="b">切换账号</el-dropdown-item>
              <el-dropdown-item command="c">清除缓存</el-dropdown-item>
              <el-dropdown-item command="d">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div> -->
    <el-dialog title="请重新选择学员" :visible.sync="centerDialogVisible" width="30%" center :show-close="false" class="ReselectMembers">
      <div class="ReselectMembersCon">
        <ul>
          <li v-for="item in MembersData" :key="item.id">
            <div class="portrait">头像</div>
            <span>{{item.name}} {{item.number}}</span>
            <el-radio v-model="radio" :label="item.id"></el-radio>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      centerDialogVisible: false,
      radio: null,
      MembersData: []
    };
  },
  mounted () {
    this.radio = this.MembersData[0].id;
  },
  methods: {
    // loginOut () {
    //   this.$store.commit('LOGIN_OUT');
    //   /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
    //   window.location.reload();
    // },
    // handleDropDown (command) {
    //   if (command == "a") {//设备检测
    //     this.$router.push("/detection");
    //   } else if (command == "b") {//切换账号
    //     this.centerDialogVisible = true;
    //   } else if (command == "c") {//清除缓存
    //   } else if (command == "d") {//退出登录
    //     this.$confirm('您确定退出?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       this.loginOut();
    //     }).catch(() => { });
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.aside__top {
  border-bottom: 1px solid #e5e5e5;
  height: 50px;
  line-height: 50px;
  background: #fff;
  transition: left 0.25s;

  .logoBox {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .logo {
      width: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 10px;
      }
    }
  }

  .toggleNavCollapse {
    display: inline-block;
    margin-left: 8px;
    padding: 0 10px;
    font-size: 26px;
    vertical-align: middle;
    color: #333;
    cursor: pointer;
    transition: all 0.5s;

    &.active {
      transform: rotate(90deg);
    }
  }

  // .aside__top--right {
  //   position: absolute;
  //   right: 10px;
  //   top: -1px;
  //   bottom: 0px;
  //   height: 50px;
  //   > div {
  //     position: relative;
  //     display: inline-block;
  //     text-align: center;
  //     vertical-align: middle;
  //     margin-left: 10px;
  //     padding: 0 15px;
  //     cursor: pointer;

  //     &:hover::after {
  //       transform-origin: 0 0;
  //       transform: scaleX(1);
  //     }

  //     &:first-child:before {
  //       border: none;
  //     }

  //     &::after {
  //       content: "";
  //       position: absolute;
  //       left: 0;
  //       bottom: -12px;
  //       width: 100%;
  //       height: 2px;
  //       background: #ef4747;
  //       transform: scaleX(0);
  //       transform-origin: right 0;
  //       transition: transform 0.5s;
  //     }

  //     &::before {
  //       content: "";
  //       position: absolute;
  //       height: 20px;
  //       top: 50%;
  //       left: -8px;
  //       margin-top: -10px;
  //       border-left: 1px solid #ccc;
  //     }

  //     &.email {
  //       i {
  //         position: absolute;
  //         left: 18px;
  //         top: -12px;
  //         border-radius: 20px;
  //         background: red;
  //         color: #fff;
  //         text-align: center;
  //         font-size: 12px;
  //         line-height: 1.5;
  //         min-width: 20px;
  //         min-height: 20px;
  //       }
  //     }

  //     &.user-msg {
  //       .user-img {
  //         width: 34px;
  //         height: 34px;
  //         border-radius: 50%;
  //         vertical-align: middle;
  //       }

  //       .user-name {
  //         color: #758eb5;
  //         padding: 0 4px;
  //       }
  //     }

  //     .iconfont {
  //       position: relative;
  //       font-size: 24px;
  //       color: #758eb5;
  //     }
  //   }
  // }
}
// .el-dropdown {
//   .el-dropdown-link {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// }
.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.6s;
}

.breadcrumb-leave-active {
  position: absolute;
}

.ReselectMembers {
  /deep/ .el-dialog__header {
    padding: 0;
    height: 50px;
    border-bottom: 1px solid #ccc;
    line-height: 50px;
  }
  /deep/ .el-dialog--center .el-dialog__body {
    padding: 0;
  }
  /deep/ .el-dialog__footer {
    margin-top: 20px;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #ccc;
      height: 50px;
      .portrait {
        width: 40px;
        height: 40px;
        border: 1px solid #ccc;
        border-radius: 50%;
        line-height: 40px;
        text-align: center;
      }
      span {
        margin: 0 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/layout/component/top-aside.vue